import React from 'react';

const AgeRequirement = ({ updateFormData, nextStep, prevStep }) => {
  const handleContinue = () => {
    updateFormData({ meetsAgeRequirement: true });
    nextStep();
  };

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>
      
      <h1 className="question-title">AGE REQUIREMENT</h1>
      <p className="question-subtitle">Reference: <a href="https://legis.la.gov/Legis/Law.aspx?d=73003" target="_blank" rel="noopener noreferrer">La. Children's Code Tit. XV, Art. 1545</a></p>
      <p className="question-subtitle">Reference: <a href="https://legis.la.gov/legis/Law.aspx?d=1147329" target="_blank" rel="noopener noreferrer">La. Civil Code Tit. IV, Art. 90.1</a></p>


      <div className="question-content">
        <p>
          Applicants must be 18 years of age to obtain a marriage license without parental consent. If an applicant is under 18 
          years of age, both parents, the tutor of the applicant, or the person who has been awarded custody of the minor applicant 
          must appear in person with applicant. If one parent has sole custody certified documents must be presented showing sole 
          custody. No temporary orders are acceptable.
        </p>
        <p>
          A minor under the age of sixteen may not contract marriage. A minor sixteen or seventeen years of age may not contract 
          marriage with a person of the age of majority where there is an age difference of three years or greater between them.
        </p>
        
        <p className="question-link-row">
          <a
            href={`${process.env.PUBLIC_URL}/forms/parental-consent-for-marriage.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="question-document-link"
          >
            Parental Consent Form
          </a>
        </p>
      </div>
      
      <div className="question-actions">
        <button onClick={handleContinue} className="btn btn-primary">
          Next
        </button>
      </div>
    </div>
  );
};

export default AgeRequirement;
